import {
  SandpackFiles,
  SandpackLayout,
  SandpackProvider,
  SandpackProviderProps,
  SandpackTests,
} from "@codesandbox/sandpack-react";
import { useCallback, useEffect, useMemo, useRef } from "react";
import { ITestResult, ITestStatus } from "./statics";

export default function SandpackWithTests({
  files,
  setTestResults,
  spOptionz,
  handleAutoSave,
}: {
  files: SandpackFiles;
  setTestResults: React.Dispatch<React.SetStateAction<ITestStatus>>;
  spOptionz: SandpackProviderProps;
  handleAutoSave: (results: ITestResult[]) => void
}) {
  // SandpackTests onComplete'i yalnızca ilk render'da yakalıyor (listener effect'inin
  // deps'inde yok). Ref olmadan otomatik kayıt, sayfa açıldığı andaki dosyaları
  // kaydedip öğrencinin kodunun üzerine şablonu yazıyordu.
  const autoSaveRef = useRef(handleAutoSave);
  useEffect(() => {
    autoSaveRef.current = handleAutoSave;
  });

  const parseSandpackTestOutput = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (testOutput: any) => {
      /* console.log(testOutput, 111); */
      const fileTests = testOutput["/index.test.js"];

      if (!fileTests || !fileTests.describes) {
        setTestResults({ status: "IDLE", results: [] });
        return [];
      }

      const tests: ITestResult[] = [];

      for (const describeKey in fileTests.describes) {
        const describeBlock = fileTests.describes[describeKey];

        for (const testName in describeBlock.tests) {
          const test = describeBlock.tests[testName];
          tests.push({
            name: testName,
            status: test.status,
          });
        }
      }
      setTestResults({ status: "IDLE", results: tests });
      autoSaveRef.current(tests);
    },
    [setTestResults]
  );

  const memoTests = useMemo(() => {
    return (
      <SandpackProvider {...spOptionz} files={files} className="!h-full">
        <SandpackLayout className="!h-full">
          <SandpackTests
            watchMode={true}
            showVerboseButton={false}
            showWatchButton={false}
            className="!h-full"
            onComplete={parseSandpackTestOutput}
          />
        </SandpackLayout>
      </SandpackProvider>
    );
  }, [files, parseSandpackTestOutput, spOptionz]);

  return memoTests;
}
